import { useRef, useState } from 'react';
import { CarouselArrowButton } from '@platform/components';
import { TestimonialCard } from './TestimonialCard';
import { TESTIMONIALS } from './data/testimonials';

const CARD_GAP = 32;

export const TestimonialsSection = () => {
  const [index, setIndex] = useState(0);
  const trackRef = useRef<HTMLDivElement | null>(null);

  const scrollTo = (direction: 'left' | 'right') => {
    if (!trackRef.current || trackRef.current.children.length === 0) return;

    const cardWidth = (trackRef.current.children[0] as HTMLElement).clientWidth + CARD_GAP;
    const next =
      direction === 'left' ?
        Math.max(0, index - 1)
      : Math.min(TESTIMONIALS.length - 1, index + 1);

    setIndex(next);
    trackRef.current.style.translate = `-${next * cardWidth}px`;
  };

  return (
    <section className='flex flex-col gap-10 bg-white px-4 pt-10 pb-12 sm:px-6 md:gap-16 md:pl-24 md:pr-8 md:pt-12 md:pb-20'>
      <div className='flex flex-col gap-3'>
        <span className='text-base font-bold uppercase leading-[1.875] text-brand-600'>
          Voices from the program
        </span>
        <h2 className='text-3xl font-semibold text-gray-600 sm:text-4xl md:text-display-md'>
          Where professional growth meets social impact
        </h2>
      </div>

      <div className='flex flex-col gap-8 sm:overflow-hidden'>
        <div
          ref={trackRef}
          className='flex flex-col gap-6 sm:flex-row sm:gap-8 sm:transition-transform sm:duration-300 sm:ease-out'
        >
          {TESTIMONIALS.map((testimonial) => (
            <TestimonialCard key={testimonial.name} testimonial={testimonial} />
          ))}
        </div>

        <div className='hidden gap-8 sm:flex'>
          <CarouselArrowButton
            direction='left'
            onClick={() => scrollTo('left')}
            disabled={index === 0}
            ariaLabel='Previous testimonial'
          />
          <CarouselArrowButton
            direction='right'
            onClick={() => scrollTo('right')}
            disabled={index === TESTIMONIALS.length - 1}
            ariaLabel='Next testimonial'
          />
        </div>
      </div>
    </section>
  );
};
